<template>
  <div>
    <h1 class="headline">Can we communicate with you electronically?</h1>
    <p>This includes official notices, meeting packages, and newsletters. Help us go green and reduce paper usage. </p>

    <div class="toggle-list mdl-shadow--2dp">

      <!-- Yes Choice -->
      <toggle-list-item
        value="yes"
        icon="sentiment_very_satisfied"
        toggle-icon="check"
        text="Yes, I consent to receiving all communications electronically."
        :checked-status="comms === 'yes'"
        toggle-class="toggle-content-action"
        @inputting="selectItem"
      ></toggle-list-item>

      <!-- No choice -->
      <toggle-list-item
        value="no"
        icon="sentiment_dissatisfied"
        toggle-icon="check"
        text="No, I do not consent to electronic communications."
        :checked-status="comms === 'no'"
        toggle-class="toggle-content-action"
        @inputting="selectItem"
      ></toggle-list-item>

    </div>

    <div class="App-buttons">
      <button-component
        direction="back"
        value="Back"
        ></button-component>
      <button-component
        color="primary"
        value="Next Step"
        :is-disabled="isDisabled"
        ></button-component>
    </div>
  </div>
</template>

<script>
import ButtonComponent from './Button.vue';
import ToggleListItem from './Questions/ToggleListItem.vue';

import {mapActions, mapGetters} from 'vuex';

export default {
  components: {
    ButtonComponent,
    ToggleListItem
  },
  computed: {
    ...mapGetters({comms: 'comms/comms'}),
    isDisabled() {
      return !this.comms;
    }
  },
  methods: {
    ...mapActions('comms', ['setComms']),
    selectItem(value) {
      this.setComms(value);
    }
  }
};
</script>

<style scoped>
.toggle-content {
  height: 75px;
}
</style>
